import Awaitable from 'spiceutils/dist/Awaitable'
/**
 * Confirmation extends the Awaitable class to allow it to store data in
 *   adddition to its normal functionality
 */
class Confirmation extends Awaitable {
  /**
   * Create a confirmation
   * @param {Object} options - object containing arbitrary key-value pairs to be recorded on this object
   */
  constructor(options) {
    super()

    Object.entries(options).forEach(([key, value]) => {
      this[key] = value
    })
  }
}

export default Confirmation
